/**
 * Elvorn — « Les instants Elvorn » : lecture automatique des vidéos verticales.
 * JavaScript natif, aucune dépendance.
 * - Silencieuses, en boucle, lues seulement quand elles sont visibles, mises en pause quand elles sortent de l'écran.
 * - Chargement progressif : une vidéo ne commence à se charger que lorsqu'elle approche de l'écran.
 * - Respecte « réduire les animations » : pas de lecture automatique, lecture au clic.
 * - Une commande lecture / pause permet toujours d'arrêter une vidéo.
 */
(function () {
  'use strict';

  if (window.elvInstantsLoaded) return;
  window.elvInstantsLoaded = true;

  var reduceMotion = window.matchMedia
    ? window.matchMedia('(prefers-reduced-motion: reduce)')
    : { matches: false };

  var LABEL_PAUSE = 'Mettre la vidéo en pause';
  var LABEL_PLAY = 'Lire la vidéo';
  var registry = [];

  function setState(item, playing) {
    item.card.toggleAttribute('data-paused', !playing);
    if (item.button) item.button.setAttribute('aria-label', playing ? LABEL_PAUSE : LABEL_PLAY);
  }

  function markReady(item) {
    item.card.setAttribute('data-ig-ready', '');
  }

  function prime(item) {
    if (item.primed) return;
    item.primed = true;
    item.video.preload = 'metadata';
    item.video.load();
  }

  function start(item, force) {
    if (!force && (item.userPaused || reduceMotion.matches)) return;
    item.video.muted = true;
    var attempt = item.video.play();
    if (attempt && typeof attempt.then === 'function') {
      attempt
        .then(function () {
          setState(item, true);
          markReady(item);
        })
        .catch(function () {
          // Lecture automatique refusée (économie d'énergie, par exemple) : l'image reste affichée.
          setState(item, false);
          markReady(item);
        });
    } else {
      setState(item, true);
      markReady(item);
    }
  }

  function toggle(item) {
    if (item.video.paused) {
      item.userPaused = false;
      prime(item);
      start(item, true);
    } else {
      item.userPaused = true;
      item.video.pause();
      setState(item, false);
    }
  }

  function init(root) {
    if (!root || root.dataset.elvIgReady) return;
    root.dataset.elvIgReady = '1';

    var items = Array.prototype.slice
      .call(root.querySelectorAll('[data-elv-ig-card]'))
      .map(function (card) {
        return {
          card: card,
          video: card.querySelector('video'),
          button: card.querySelector('[data-elv-ig-toggle]'),
          userPaused: false,
          primed: false,
          inView: false
        };
      })
      .filter(function (item) {
        return item.video;
      });

    if (!items.length) return;

    var byVideo = new Map();

    items.forEach(function (item) {
      var video = item.video;
      video.muted = true;
      video.loop = true;
      video.playsInline = true;
      video.setAttribute('playsinline', '');
      video.removeAttribute('controls');
      video.disablePictureInPicture = true;

      byVideo.set(video, item);
      registry.push(item);

      video.addEventListener('playing', function () {
        setState(item, true);
        markReady(item);
      });
      video.addEventListener('pause', function () {
        setState(item, false);
      });

      if (item.button) {
        item.button.addEventListener('click', function () {
          toggle(item);
        });
      }

      if (reduceMotion.matches) {
        setState(item, false);
        markReady(item);
      }
    });

    if (!('IntersectionObserver' in window)) {
      items.forEach(function (item) {
        prime(item);
        start(item, false);
      });
      return;
    }

    var nearObserver = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (entry) {
          if (!entry.isIntersecting) return;
          nearObserver.unobserve(entry.target);
          prime(byVideo.get(entry.target));
        });
      },
      { rootMargin: '400px 0px' }
    );

    var viewObserver = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (entry) {
          var item = byVideo.get(entry.target);
          if (!item) return;
          item.inView = entry.isIntersecting;
          if (entry.isIntersecting) {
            prime(item);
            start(item, false);
          } else {
            item.video.pause();
          }
        });
      },
      { threshold: 0.4 }
    );

    items.forEach(function (item) {
      nearObserver.observe(item.video);
      viewObserver.observe(item.video);
    });
  }

  function boot(scope) {
    (scope || document).querySelectorAll('[data-elv-ig]').forEach(init);
  }

  document.addEventListener('visibilitychange', function () {
    registry.forEach(function (item) {
      if (!item.video.isConnected) return;
      if (document.hidden) {
        item.video.pause();
      } else if (item.inView) {
        start(item, false);
      }
    });
  });

  // Éditeur de thème : réinitialisation à chaque rechargement de la section, et défilement vers le bloc sélectionné.
  document.addEventListener('shopify:section:load', function (event) {
    boot(event.target);
  });

  document.addEventListener('shopify:block:select', function (event) {
    var card = event.target;
    if (card && card.matches && card.matches('[data-elv-ig-card]')) {
      card.scrollIntoView({ behavior: 'smooth', block: 'nearest', inline: 'center' });
    }
  });

  boot();
})();